import { render, staticRenderFns } from "./PaperPlane.vue?vue&type=template&id=4da5b884&"
import script from "./PaperPlane.vue?vue&type=script&lang=js&"
export * from "./PaperPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports